@let $prepend = prepend();
@let $append = append();

@if ($prepend && !$prepend.hide) {
  <span class="col-auto">
    <ng-container [ngTemplateOutlet]="$prepend.template" />
  </span>
}

<span
  class="col text-overflow"
  [autoClose]="autoClose()"
  [closeDelay]="closeDelay()"
  [container]="container()"
  [disableTooltip]="disableTooltip() || !isTruncated()"
  [ngbTooltip]="tooltip()"
  [openDelay]="openDelay()"
  [placement]="placement()"
  [tooltipClass]="tooltipClass()"
  [triggers]="triggers()"
  #wrapper>
  <span #content>
    <ng-content />
  </span>
</span>

@if ($append && !$append.hide) {
  <span class="col-auto">
    <ng-container [ngTemplateOutlet]="$append.template" />
  </span>
}
